export default __webpack_public_path__ + "static/media/Gloves of Celestial Radiance.b0b0b7ce.jpg";